import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { DeploymentUser } from "@types";

export const getDeploymentUsers = (
  deploymentId: string
): Promise<DeploymentUser[]> => {
  const path = `${DEPLOYMENT_URL}/${deploymentId}/users`;
  return authGet<{ users: DeploymentUser[] }>(path).then(
    (result) => result.users
  );
};
